<div [animate.enter]="'app-router-enter'">
  <div id="kt_header_mobile" class="kt-header-mobile">
    <div class="kt-header-mobile__logo">
      <a routerLink="/" target="_blank">
        @if (!appSession.tenant || !appSession.tenant.HasLogo()) {
          <img [src]="defaultLogo" alt="logo" height="28" />
        }
        @if (appSession.tenant && appSession.tenant.HasLogo()) {
<img [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.HasLogo()" alt="logo" height="38" />
}
            </a>
                </div>
        <div class="kt-header-mobile__toolbar">
            <button class="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left" id="kt_aside_mobile_toggler">
                <span></span>
            </button>
            <button ktToggle [options]="userMenuToggleOptions" class="kt-header-mobile__toolbar-topbar-toggler" id="kt_header_mobile_topbar_toggler">
                <i class="flaticon-more-1"></i>
            </button>
            </div>
        </div>
    <div class="kt-grid kt-grid--hor kt-grid--root">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
        <!-- BEGIN: Left Aside -->
            <button class="kt-aside-close" id="kt_aside_close_btn">
                <i class="la la-close" aria-label="l('Close')"></i>
        </button>
            <div id="kt_aside" ktOffcanvas [options]="menuCanvasOptions" class="kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop">
                <!-- BEGIN: Brand -->
                <theme3-brand></theme3-brand>
                <!-- END: Brand -->
            <!-- BEGIN: Aside Menu -->
                <div id="kt_aside_menu_wrapper" class="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid">
            @if (currentTheme.isLeftMenuUsed) {
<side-bar-menu></side-bar-menu>
}
                </div>
            <!-- END: Aside Menu -->
        </div>
            <!-- END: Left Aside -->
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                <!-- BEGIN: Header -->
                <div ktHeader #ktHeader class="kt-header kt-grid__item" id="kt_header">
                    <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
                    </div>
                    <topbar></topbar>
                </div>
                <!-- END: Header -->
                <div class="d-lg-none p-3 mobile-subscription-warning">
            @if (subscriptionStatusBarVisible()) {
<div
                 [ngClass]="{'hidden': !subscriptionStatusBarVisible()}" class="d-inline-block d-sm-none mt-3 ml-3">
              @if (tenant.isInTrialPeriod && !subscriptionIsExpiringSoon()) {
                <span [innerHTML]="getTrialSubscriptionNotification()"></span>
              }
              @if (subscriptionIsExpiringSoon()) {
                <a routerLink="/app/admin/subscription-management">
                  @if (subscriptionIsExpiringSoon() && tenant.isInTrialPeriod) {
                    <span><i class="fa fa-exclamation-circle"></i> {{getExpireNotification("TrialExpireNotification")}}</span>
                  }
                  @if (subscriptionIsExpiringSoon() && !tenant.isInTrialPeriod) {
                    <span><i class="fa fa-exclamation-circle"></i> {{getExpireNotification("SubscriptionExpireNotification")}}</span>
                  }
                </a>
              }
            </div>
          }
        </div>
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
          <router-outlet></router-outlet>
        </div>
        <footer-bar></footer-bar>
      </div>
    </div>
  </div>
  <kt-scroll-top></kt-scroll-top>
</div>
